import {MedicalReportSmall} from '@/features/medical-reports/types'
import {UserByPatient} from '@/features/users/types'
import {DateRange, MedicalReportType} from '@/types'
import {z} from 'zod'

export const MedicalRecordSearchParams = DateRange.merge(
    z.object({
        projectId: z.string().trim().optional(),
        createdByUserId: z.string().optional(),
        medicalRecordReportTypeId: z.string().optional(),
        page: z.coerce.number().positive().int().default(1),
        limit: z.coerce.number().positive().int().default(50)
    })
)
export type MedicalRecordSearchParams = z.infer<typeof MedicalRecordSearchParams>

export const CreateMedicalReportSearchParams = z.object({
    projectId: z.string().optional(),
    medicalReportType: MedicalReportType.optional()
})
export type CreateMedicalReportSearchParams = z.infer<typeof CreateMedicalReportSearchParams>

export const MedicalRecord = z.object({
    id: z.string().min(1).nullable(),
    code: z.number().positive().nullable(),
    createdAt: z.string().nullable(),
    status: z.enum(['open', 'closed']).nullish(), // todo: update this value after the PRI is finished
    reports: z.array(MedicalReportSmall)
})
export type MedicalRecord = z.infer<typeof MedicalRecord>

export const MedicalRecordAggregatedPrint = z.object({
    id: z.string().min(1),
    date: z.string().min(1),
    user: UserByPatient,
    attachment: z
        .object({
            name: z.string().min(1),
            url: z.string().url(),
            presignedUrl: z.string().url()
        })
        .nullable()
})
export type MedicalRecordAggregatedPrint = z.infer<typeof MedicalRecordAggregatedPrint>
